<div class="authentication-bg min-vh-100">
  <div class="bg-overlay bg-white"></div>
  <!-- Language Switcher -->
  <div class="language-switcher-container">
    <app-language-switcher></app-language-switcher>
  </div>
  <div class="container">
    <div class="col-row">
      <div class="col-md-6">
        <div class="w-full">
          <div class="mb-4 mb-md-5 responsive-auth-header">
            <a routerLink="/" class="d-block auth-logo">
              <div class="d-flex gap-3">
                <img src="assets/images/HC-logo.svg" alt="HotelCard Logo" class="logo" />
                <img src="assets/images/hotelcard-text.svg" alt="HotelCard" class="hotelcard-text" />
                <span class="mt-3 responsive-divider">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="2"
                    height="30"
                    viewBox="0 0 2 30"
                    fill="none"
                  >
                    <path d="M1.24854 2.18557e-08L1.24853 30" stroke="white" />
                  </svg>
                </span>
                <span class="text-white extranet">Extranet</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column">
      <div class="row justify-content-center my-auto">
        <div class="col-lg-6">
          <div class="responsive-center-card responsive-auth-page-card">
            <div class="card auth-cover-card overflow-hidden">
              <div class="row g-0">
                <div class="col-lg-12">
                  <div
                    class="login-form-card bg-white h-100 d-flex align-items-center justify-content-center auth-card"
                  >
                    <div class="w-full">

                      <!-- State 1: Validating token -->
                      @if (tokenChecking) {
                        <div class="text-center py-4">
                          <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">{{ 'AUTH.RESET_PASSWORD.VALIDATING_TOKEN' | translate }}</span>
                          </div>
                          <p class="text-muted mt-3 mb-0">{{ 'AUTH.RESET_PASSWORD.VALIDATING_TOKEN' | translate }}</p>
                        </div>
                      }

                      <!-- State 2: Invalid / expired token (backend confirmed it's actually bad) -->
                      @if (!tokenChecking && invalidLink) {
                        <div class="text-center">
                          <div class="mb-4">
                            <lucide-icon name="link-2-off" class="text-danger icon-xxl"></lucide-icon>
                          </div>
                          <h5 class="welcome-text mb-3">
                            {{ 'AUTH.RESET_PASSWORD.INVALID_LINK_TITLE' | translate }}
                          </h5>
                          <p class="text-muted mb-4">
                            {{ 'AUTH.RESET_PASSWORD.INVALID_LINK' | translate }}
                          </p>
                          <!-- Resend reset link — visible ONLY when token is invalid -->
                          <div class="mt-4">
                            <hc-button variant="primary" [fullWidth]="true" (clicked)="goToForgotPassword()">
                              {{ 'AUTH.RESET_PASSWORD.REQUEST_NEW_LINK' | translate }}
                            </hc-button>
                          </div>
                          <div class="mt-3">
                            <a routerLink="/account/login" class="text-decoration-underline forgot-password">
                              {{ 'AUTH.RESET_PASSWORD.BACK_TO_LOGIN' | translate }}
                            </a>
                          </div>
                        </div>
                      }

                      <!-- State 2b: Couldn't check the token (rate limit / network / server error) —
                           the token itself may still be fine, so offer "try again", not a new link. -->
                      @if (!tokenChecking && tokenCheckUnavailable) {
                        <div class="text-center">
                          <div class="mb-4">
                            <lucide-icon name="refresh-cw" class="text-warning icon-xxl"></lucide-icon>
                          </div>
                          <h5 class="welcome-text mb-3">
                            {{ 'AUTH.RESET_PASSWORD.CHECK_UNAVAILABLE_TITLE' | translate }}
                          </h5>
                          <p class="text-muted mb-4">
                            @if (tokenCheckUnavailableReason === 'throttled') {
                              {{ 'AUTH.RESET_PASSWORD.TOO_MANY_ATTEMPTS' | translate }}
                            } @else if (tokenCheckUnavailableReason === 'network') {
                              {{ 'AUTH.RESET_PASSWORD.CONNECTION_ERROR' | translate }}
                            } @else {
                              {{ 'AUTH.RESET_PASSWORD.CHECK_UNAVAILABLE' | translate }}
                            }
                          </p>
                          <div class="mt-4">
                            <hc-button variant="primary" [fullWidth]="true" (clicked)="retryTokenValidation()">
                              {{ 'AUTH.RESET_PASSWORD.TRY_AGAIN' | translate }}
                            </hc-button>
                          </div>
                          <div class="mt-3">
                            <a routerLink="/account/login" class="text-decoration-underline forgot-password">
                              {{ 'AUTH.RESET_PASSWORD.BACK_TO_LOGIN' | translate }}
                            </a>
                          </div>
                        </div>
                      }

                      <!-- State 3: Valid token — show the reset form -->
                      @if (!tokenChecking && !invalidLink && !tokenCheckUnavailable) {
                        <div class="text-white-50 mb-4">
                          <h5 class="welcome-text">{{ 'AUTH.RESET_PASSWORD.TITLE' | translate }}</h5>
                          <p class="reset-description">{{ 'AUTH.RESET_PASSWORD.SUBTITLE' | translate }}</p>
                        </div>

                        <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
                          <!-- New Password -->
                          <div class="mb-3">
                            <label class="form-label">{{ 'AUTH.RESET_PASSWORD.NEW_PASSWORD_LABEL' | translate }}</label>
                            <div class="position-relative">
                              <!-- TODO: account pages use dark theme — needs design review before migrating to hc-input -->
                              <input
                                [type]="showPassword ? 'text' : 'password'"
                                class="form-control form-input-dark"
                                formControlName="password"
                                autocomplete="new-password"
                                [placeholder]="'AUTH.RESET_PASSWORD.NEW_PASSWORD_PLACEHOLDER' | translate"
                                [ngClass]="{'is-invalid': resetForm.get('password')?.invalid && (resetForm.get('password')?.touched || formSubmitted)}">
                              <button
                                type="button"
                                class="position-absolute password-icon translate-middle-y pe-3 btn p-0 border-0 bg-transparent"
                                (click)="togglePasswordVisibility()"
                                [attr.aria-label]="showPassword ? ('AUTH.LOGIN.HIDE_PASSWORD' | translate) : ('AUTH.LOGIN.SHOW_PASSWORD' | translate)">
                                <lucide-icon [name]="showPassword ? 'eye' : 'eye-off'"></lucide-icon>
                              </button>
                            </div>
                            @if (resetForm.get('password')?.invalid && (resetForm.get('password')?.touched || formSubmitted)) {
                              <p class="hc-form-field__helper hc-form-field__helper--error mt-1">
                                @if (resetForm.get('password')?.errors?.['required']) {
                                  <span>{{ 'AUTH.COMMON.PASSWORD_REQUIRED' | translate }}</span>
                                }
                                @if (resetForm.get('password')?.errors?.['passwordTooShort']) {
                                  <span>{{ 'password_hints.error_too_short' | translate }}</span>
                                }
                                @if (resetForm.get('password')?.errors?.['passwordNoLetter']) {
                                  <span>{{ 'password_hints.error_no_letter' | translate }}</span>
                                }
                                @if (resetForm.get('password')?.errors?.['passwordNoNumber']) {
                                  <span>{{ 'password_hints.error_no_number' | translate }}</span>
                                }
                              </p>
                            }
                            <app-password-hints [password]="resetForm.get('password')?.value"></app-password-hints>
                          </div>

                          <!-- Confirm Password -->
                          <div class="mb-3">
                            <label class="form-label">{{ 'AUTH.RESET_PASSWORD.CONFIRM_PASSWORD_LABEL' | translate }}</label>
                            <div class="position-relative">
                              <!-- TODO: account pages use dark theme — needs design review before migrating to hc-input -->
                              <input
                                [type]="showConfirmPassword ? 'text' : 'password'"
                                class="form-control form-input-dark"
                                formControlName="password_confirmation"
                                autocomplete="new-password"
                                [placeholder]="'AUTH.RESET_PASSWORD.CONFIRM_PASSWORD_PLACEHOLDER' | translate"
                                [ngClass]="{'is-invalid': (resetForm.get('password_confirmation')?.invalid && (resetForm.get('password_confirmation')?.touched || formSubmitted)) || (resetForm.errors?.['mismatch'] && (resetForm.get('password_confirmation')?.touched || formSubmitted))}">
                              <button
                                type="button"
                                class="position-absolute password-icon translate-middle-y pe-3 btn p-0 border-0 bg-transparent"
                                (click)="toggleConfirmPasswordVisibility()"
                                [attr.aria-label]="showConfirmPassword ? ('AUTH.LOGIN.HIDE_PASSWORD' | translate) : ('AUTH.LOGIN.SHOW_PASSWORD' | translate)">
                                <lucide-icon [name]="showConfirmPassword ? 'eye' : 'eye-off'"></lucide-icon>
                              </button>
                            </div>
                            @if (resetForm.get('password_confirmation')?.invalid && (resetForm.get('password_confirmation')?.touched || formSubmitted)) {
                              <p class="hc-form-field__helper hc-form-field__helper--error mt-1">
                                @if (resetForm.get('password_confirmation')?.errors?.['required']) {
                                  <span>{{ 'AUTH.RESET_PASSWORD.CONFIRM_REQUIRED' | translate }}</span>
                                }
                              </p>
                            }
                            @if (resetForm.errors?.['mismatch'] && (resetForm.get('password_confirmation')?.touched || formSubmitted)) {
                              <p class="hc-form-field__helper hc-form-field__helper--error mt-1">
                                {{ 'AUTH.RESET_PASSWORD.PASSWORDS_DONT_MATCH' | translate }}
                              </p>
                            }
                          </div>

                          <div class="mt-4">
                            <hc-button
                              variant="primary"
                              [type]="'submit'"
                              size="md"
                              [fullWidth]="true"
                              [loading]="loading"
                              [disabled]="loading">
                              {{ loading ? ('AUTH.RESET_PASSWORD.SUBMITTING' | translate) : ('AUTH.RESET_PASSWORD.SUBMIT' | translate) }}
                            </hc-button>
                          </div>

                          @if (resetError) {
                            <p class="text-danger mt-2 mb-0">
                              {{ resetErrorKey | translate }}
                            </p>
                          }

                          <div class="mt-4 text-center">
                            <a routerLink="/account/login" class="text-decoration-underline forgot-password">
                              {{ 'AUTH.RESET_PASSWORD.BACK_TO_LOGIN' | translate }}
                            </a>
                          </div>
                        </form>
                      }

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
